import Vue from 'vue';
import Component from 'vue-class-component';

import BbModal from 'common/components/BbModal';
import BbForm from 'components/BbForm';
import BbField from 'components/BbField';
import dayjs from 'dayjs';
import DateTimePicker from 'components/DateTimePicker';
import SpecialReservationFormMutation from 'assets/graphql/mutations/SpecialReservationFormMutation.graphql';

@Component({
  components: {
    BbModal,
    BbForm,
    BbField,
    DateTimePicker,
  },
  props: {
    code: {
      type: String,
      required: false,
    },
    activity: {
      type: Object,
      required: true,
    },
  },
})
export default class ReservationModalComponent extends Vue {
  form = {
    email: '',
    phone: '',
    dates: [],
  };
  dateRanges = {
    to: dayjs().add(2, 'day').toDate(),
  };
  dateError = false;
  dateExpError = false;
  dateTimeError = false;
  phoneError = false;
  formStep = 'uncompleted';
  dates = [];
  expirationDate = '';
  dateDiffs = [];

  getDates() {
    this.form.dates[0] = this.formatDate(
      this.$refs.option0.date,
      this.$refs.option0.currentTime,
    );
    this.form.dates[1] = this.formatDate(
      this.$refs.option1.date,
      this.$refs.option1.currentTime,
    );
    this.form.dates[2] = this.formatDate(
      this.$refs.option2.date,
      this.$refs.option2.currentTime,
    );
  }

  formatDate(date, time) {
    const dayjdDate = dayjs(date).format('MM DD YYYY');
    const timeAndDate = `${dayjdDate} ${time}`;
    const formated = dayjs(timeAndDate).format('MM DD YYYY HH:mm');
    return new Date(formated);
  }

  checkExpirationDate(date) {
    this.expirationDate = dayjs(this.activity.expiration_date).format(
      'DD/MM/YYYY',
    );
    const expiration = new Date(this.activity.expiration_date);
    // adds one day to allow user to select expiration date inclusive
    return expiration.getTime() + 24 * 60 * 60 * 1000 - date.getTime();
  }

  isFormValid() {
    this.dateError = false;
    this.dateTimeError = false;
    this.phoneError = false;
    this.dateExpError = false;

    this.dates = [
      this.$refs.option0.date,
      this.$refs.option1.date,
      this.$refs.option2.date,
    ];
    if (this.dates.includes(null)) {
      this.dateError = true;
    }

    const dates = [
      this.form.dates[0].getTime(),
      this.form.dates[1].getTime(),
      this.form.dates[2].getTime(),
    ];
    const datesSet = new Set(dates);
    const cleanedDates = [...datesSet];
    if (dates.length !== cleanedDates.length) {
      this.dateTimeError = true;
    }

    const hasDuplicatedDate = [
      this.checkExpirationDate(this.form.dates[0]),
      this.checkExpirationDate(this.form.dates[1]),
      this.checkExpirationDate(this.form.dates[2]),
    ].some(v => v < 0);
    if (hasDuplicatedDate) {
      this.dateExpError = true;
    }

    if (this.form.phone.length < 8) {
      this.phoneError = true;
    }
    return (
      !this.dateError &&
      !this.dateTimeError &&
      !this.phoneError &&
      !this.dateExpError
    );
  }

  sendForm() {
    this.getDates();
    if (this.isFormValid()) {
      this.formStep = 'loading';
      this.$apollo
        .mutate({
          mutation: SpecialReservationFormMutation,
          variables: {
            input: {
              activity_id: this.activity.id,
              activity_name: this.activity.name,
              code: this.code,
              buyer_email: this.form.email,
              buyer_telephone: this.form.phone,
              date_option_1: dayjs(this.form.dates[0]).format(
                'YYYY-MM-DDTHH:mm',
              ),
              date_option_2: dayjs(this.form.dates[1]).format(
                'YYYY-MM-DDTHH:mm',
              ),
              date_option_3: dayjs(this.form.dates[2]).format(
                'YYYY-MM-DDTHH:mm',
              ),
              partner: this.activity.partneractivity.partner.id,
              partner_activity_locations:
                this.activity.partneractivity.locations.map(
                  location => location.id,
                ),
            },
          },
        })
        .then(res => {
          this.errors = res.data.special_reservation.errors;
        })
        .finally(() => {
          if (this.errors.length === 0) {
            this.formStep = 'success';
          } else {
            this.formStep = 'error';
          }
        });
    }
  }

  closeModal() {
    this.$parent.$emit('close');
  }
}
